const AuthStatment = ({ title, description }) => {
  return (
    <p className='my-2 flex flex-wrap items-center justify-center gap-1 px-4 text-center max-sm:mt-[23px] max-sm:mb-2 lg:mt-6 lg:mb-2'>
      <span className='text-sm font-bold text-red-600 max-lg:text-base max-md:text-sm max-sm:text-xs lg:text-xl'>
        {title}
      </span>
      <span className='font-medium max-lg:text-[15px] max-md:text-sm max-sm:text-xs lg:text-lg'>
        {description}
      </span>
    </p>
  );
};

export default AuthStatment;
